export default __webpack_public_path__ + "static/media/main.e8d30e65.jpg";